import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'

let observer = null
const LOAD_IMG_EVENT_TYPE = 'loadImage'

const onIntersection = (entries, io) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      io.unobserve(entry.target)
      entry.target.dispatchEvent(new CustomEvent(LOAD_IMG_EVENT_TYPE))
    }
  })
}

const Image = ({
  className,
  lazy,
  threshold = 0.5,
  src,
  placeholder,
  block,
  width,
  height,
  alt,
  mode,
  onClick,
  ...props
}) => {
  const [loaded, setLoaded] = useState(false)
  const imgRef = useRef(null)

  const imageStyle = {
    display: block ? 'block' : undefined,
    width,
    height,
    objectFit: mode,
  }

  useEffect(() => {
    if (!lazy) {
      setLoaded(true)
      return
    }

    const handleLoadImage = () => setLoaded(true)

    const imgElement = imgRef.current
    imgElement &&
      imgElement.addEventListener(LOAD_IMG_EVENT_TYPE, handleLoadImage)

    return () => {
      imgElement.removeEventListener(LOAD_IMG_EVENT_TYPE, handleLoadImage)
    }
  }, [lazy])

  useEffect(() => {
    if (!lazy) {
      return
    }

    if (!observer) {
      observer = new IntersectionObserver(onIntersection, { threshold })
    }

    imgRef.current && observer.observe(imgRef.current)
  }, [lazy, threshold])

  return (
    <img
      className={className}
      ref={imgRef}
      src={loaded ? src : placeholder}
      alt={alt}
      onClick={onClick}
      aria-hidden
      style={{ ...props.style, ...imageStyle }}
    />
  )
}

Image.propTypes = {
  className: PropTypes.string,
  lazy: PropTypes.bool,
  threshold: PropTypes.number,
  src: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.number,
  alt: PropTypes.string,
  mode: PropTypes.string,
  onClick: PropTypes.func,
}

export default Image
